const moment = require('moment');

// WARNING don't change order of items, adding new one place it in proper order place
const list = [
  {
    name: 'myBookProject',
    index: 0,
    daysBetweenPreviousMilestone: 0,
  },
  {
    name: 'myWriterMatch',
    index: 1,
    daysBetweenPreviousMilestone: 28,
  },
  {
    name: 'myInterviews',
    index: 2,
    daysBetweenPreviousMilestone: 56,
  },
  {
    name: 'myBookOutlineAndSample',
    index: 3,
    daysBetweenPreviousMilestone: 42,
  },
  {
    name: 'uploadingMyPhotos',
    index: 4,
    daysBetweenPreviousMilestone: 28,
  },
  {
    name: 'myDraftManuscript',
    index: 5,
    daysBetweenPreviousMilestone: 63,
  },
  {
    name: 'myBookCover',
    index: 6,
    daysBetweenPreviousMilestone: 28,
  },
  {
    name: 'proofOfMyBook',
    index: 7,
    daysBetweenPreviousMilestone: 28,
  },
];

class MilestoneTimelines extends Array {
  static #instance;

  static getInstance() {
    if (!MilestoneTimelines.#instance) {
      MilestoneTimelines.#instance = Object.freeze(new MilestoneTimelines(...list));
    }
    return MilestoneTimelines.#instance;
  }

  static extensionFeeDaysDuration = 56;

  constructor(...args) {
    super(...args);
  }

  getNames() {
    return this.map(({ name }) => name);
  }

  getIndexes() {
    return list.reduce((enumList, { name, index }) => {
      enumList[name] = index;
      return enumList;
    }, {});
  }

  static getStartedTimelineSchedule() {
    const timelines = this.getInstance();
    const timelinesNames = timelines.getNames();

    return timelinesNames.reduce((acc, curr, index) => {
      if (!index) {
        acc.push({ name: curr, targetDate: new Date() });
      }
      if (curr === timelinesNames[5]) {
        const outlineDate = acc[3].targetDate;
        const prevDate = moment(outlineDate).add(timelines[index].daysBetweenPreviousMilestone, 'd').toDate();
        acc.push({ name: curr, targetDate: prevDate });
      } else if (curr === timelinesNames[7]) {
        const draftDate = acc[5].targetDate;
        const prevDate = moment(draftDate).add(timelines[index].daysBetweenPreviousMilestone, 'd').toDate();
        acc.push({ name: curr, targetDate: prevDate });
      } else if (index) {
        let prevDate = acc[index - 1].targetDate;
        prevDate = moment(prevDate).add(timelines[index].daysBetweenPreviousMilestone, 'd').toDate();
        acc.push({ name: curr, targetDate: prevDate });
      }
      return acc;
    }, []);
  }


  static getStartedExtensionFeeDate() {
    const startedTimelineSchedule = this.getStartedTimelineSchedule();

    return moment(startedTimelineSchedule[startedTimelineSchedule.length - 1].targetDate)
      .add(MilestoneTimelines.extensionFeeDaysDuration, 'd').toDate();
  }
}

module.exports = MilestoneTimelines;
